import { ComponentType } from "react"
import { With } from "../common/componentExtensions"

import Store from "./tipiUsoCaldaiaStore"
import Actions from "./tipiUsoCaldaiaActions"

export let withTipiUsoCaldaia = <TProps extends {}>(cmp: ComponentType<TProps>) => With(cmp, Store, () => Actions.getAll());